import { getBasePath } from '../../utils/config';
import {
  IloginDbUserAPIResponse,
  IUpdateUserAPIBody,
  IupdateUserImageAPIResponse,
  TUpdateUserApiResponse,
} from 'api/endpoints/user/user.response.interface';

export const loginDbUserAPI = async ({
  token,
}: {
  token: string;
}): Promise<IloginDbUserAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/user/login/client`, params);
  const data = await response.json();
  return { response, data };
};

export const updateDbUserAPI = async ({
  body,
  token,
}: {
  body: IUpdateUserAPIBody;
  token: string;
}): Promise<TUpdateUserApiResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/user/update_user`, params);
  const data = await response.json();
  return { response, data };
};

export const updateUserAvatarAPI = async ({
  userId,
  image,
  token,
}: {
  userId: string;
  image: File;
  token: string;
}): Promise<IupdateUserImageAPIResponse> => {
  const url = `${getBasePath()}/upload/client_user_profile_image?user_id=${userId}`;
  const formData = new FormData();
  formData.append('image', image);
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const data = await response.json();
  return { response, data };
};

export const changePasswordAPI = async (
  auth0Id: any,
  newPsw: string,
  token: string
): Promise<any> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      filter: { id: auth0Id },
      update: { password: newPsw },
    }),
  };
  const response = await fetch(`${getBasePath()}/user/update_user_password`, params);
  const data = await response.json();
  return { response, data };
};

export const resendEmailVerificationAPI = async ({
  auth0_id,
  token,
}: {
  auth0_id: string;
  token: string;
}): Promise<any> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/user/resend_verification_email?user_auth0_id=${auth0_id}`,
    params
  );
  const data = await response.json();
  return { response, data };
};
